import axios from 'axios';
import { logout, setUser, resetAuthState } from '../redux/slice/authSlice';
import { persistor, store } from '../redux/store';

const API_URL = 'https://dev-api.thoorigai.net/api/auth/users';

const handleApiError = (error) => {
  if (error.response?.data) {
    return error.response.data;
  }
  return { success: false, message: 'An error occurred' };
};

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('accessToken');
      store.dispatch(resetAuthState());
      store.dispatch(logout());
      persistor.purge();
    }
    return Promise.reject(error);
  }
);

export const login = async (data, dispatch) => {
  try {
    const response = await axios({
      url: `${API_URL}/login`,
      method: 'POST',
      data,
      withCredentials: true,
    });

    if (response.data.success && response.data.data) {
      localStorage.setItem('accessToken', response.data.data.accessToken);
      dispatch(setUser(response.data));
    }

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const mobileSignup = async (data) => {
  try {
    const response = await axios({
      url: `${API_URL}/mobile-signup`,
      method: 'POST',
      data: {
        phone_no: data.phone_no,
        username: data.username,
        password: data.password,
      },
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const verifyOTP = async (data, dispatch) => {
  try {
    const response = await axios({
      url: `${API_URL}/verify-otp`,
      method: 'POST',
      data: {
        phone_no: data.phone_no,
        otp: data.otp,
      },
      withCredentials: true,
    });
    console.log('responseAPI: ', response.data);

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await axios({
      url: `${API_URL}/forgot-password`,
      method: 'POST',
      data: { email },
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const resetPassword = async (resetToken, newPassword) => {
  try {
    const response = await axios({
      url: `${API_URL}/reset-password/${resetToken}`,
      method: 'POST',
      data: { newPassword },
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const logoutUser = async (dispatch) => {
  try {
    const response = await axios({
      url: `${API_URL}/logout`,
      method: 'POST',
      withCredentials: true,
    });

    if (response.data.success) {
      localStorage.removeItem('accessToken');

      dispatch(resetAuthState());
      dispatch(logout());

      await persistor.purge();
    }

    return response.data;
  } catch (error) {
    localStorage.removeItem('accessToken');
    dispatch(resetAuthState());
    dispatch(logout());
    await persistor.purge();
    return handleApiError(error);
  }
};

export const continueWithGoogle = async (idToken, dispatch) => {
  try {
    const response = await axios({
      url: `${API_URL}/google`,
      method: 'POST',
      data: { idToken },
    });

    if (response.data.success && response.data.data) {
      localStorage.setItem('accessToken', response.data.data.accessToken);
      dispatch(setUser(response.data));
    }

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const register = async (data) => {
  try {
    const response = await axios({
      url: `${API_URL}/register`,
      method: 'POST',
      data,
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const verifyEmail = async (verificationToken) => {
  try {
    const response = await axios({
      url: `${API_URL}/verify/${verificationToken}`,
      method: 'GET',
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const loginWithPhone = async (data, dispatch) => {
  try {
    const response = await axios({
      url: `${API_URL}/login-phone`,
      method: 'POST',
      data,
      withCredentials: true,
    });

    if (response.data.success && response.data.data) {
      localStorage.setItem('accessToken', response.data.data.accessToken);
      dispatch(setUser(response.data));
    }

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const forgotPasswordMobile = async (data) => {
  try {
    const response = await axios({
      url: `${API_URL}/forgot-password-mobile`,
      method: 'POST',
      data: { phone_no: data.phone_no },
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const verifyResetOTP = async (data) => {
  try {
    const response = await axios({
      url: `${API_URL}/verify-reset-otp`,
      method: 'POST',
      data: {
        phone_no: data.phone_no,
        otp: data.otp,
      },
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const resetPasswordMobile = async (data) => {
  try {
    const response = await axios({
      url: `${API_URL}/reset-password-mobile`,
      method: 'POST',
      data: {
        phone_no: data.phone_no,
        otp: data.otp,
        newPassword: data.newPassword,
      },
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const resendSignupOTP = async (data) => {
  try {
    const response = await axios({
      url: `${API_URL}/resend-signup-otp`,
      method: 'POST',
      data: { phone_no: data.phone_no },
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const resendForgotPasswordOTP = async (data) => {
  try {
    const response = await axios({
      url: `${API_URL}/resend-forgot-password-otp`,
      method: 'POST',
      data: { phone_no: data.phone_no },
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};
const authService = {
  login,
  logoutUser,
  continueWithGoogle,
  register,
  verifyEmail,
  forgotPassword,
  resetPassword,
  mobileSignup,
  verifyOTP,
  loginWithPhone,
  forgotPasswordMobile,
  verifyResetOTP,
  resetPasswordMobile,
  resendSignupOTP,
  resendForgotPasswordOTP,
};

export default authService;
